import Styles from './QuizEnroll.module.scss';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Module imports.
import axios from 'axios';
import { Typography } from '@mui/material';
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Components import.
import { useAPI } from 'components/lib';
import EnrollViewCard from 'components/global/EnrollViewCard/EnrollViewCard';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { BreadCrumbs } from 'components/global/BreadCrumbs/BreadCrumbs';

export function QuizEnroll(props) {

	const [quizList, setLabList] = useState([]);
	// eslint-disable-next-line
	const [selectedQuizs, setSelectedQuizs] = useState(new Set());
	const [resetSelections, setResetSelections] = useState(false);
	const { data, loading } = useAPI('api/c_quiz', 'GET');
	const navigate = useNavigate();


	useEffect(() => {
		if (data?.length) {
			setLabList(data);
		}
	}, [data]);

	function handleLabSelection(quizId) {
		if (selectedQuizs.has(quizId)) {
			selectedQuizs.delete(quizId);
		} else {
			selectedQuizs.add(quizId);
		}
	}

	function onEnroll() {
		const formData = {
			quizids: Array.from(selectedQuizs),
		};
		if (!selectedQuizs.size) {
			toast.dark(props.t('CommonQuiz.QuizEnroll.toast.failed'), {
				type: 'error',
				position: 'top-right',
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
			});
			return;
		}
		const options = {
			method: 'POST',
			url: `/api/c_quiz/enroll`,
			headers: {
				accept: 'application/json',
			},
			data: formData,
		};
		axios
			.request(options)
			.then(function (response) {
				let status = response.status;
				if (status === 201) {
					toast.dark(props.t('CommonQuiz.QuizEnroll.toast.success'), {
						type: 'success',
						position: 'top-right',
						autoClose: false,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
					});
					navigate(`/quiz`);
				} else {
					toast.dark(props.t('CommonQuiz.QuizEnroll.toast.error'), {
						type: 'error',
						position: 'top-right',
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
					});
					selectedQuizs.clear();
					setResetSelections(true);
				}
			})
			.catch((err) => {
				let status = err.response.status;
				console.log('error', status);
				if (status === 406) {
					toast.dark(props.t('CommonQuiz.QuizEnroll.toast.failed'), {
						type: 'error',
						position: 'top-right',
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
					});
				} else {
					toast.dark(props.t('CommonQuiz.QuizEnroll.toast.error'), {
						type: 'error',
						position: 'top-right',
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
					});
				}
				selectedQuizs.clear();
				setResetSelections(true);
				window.scrollTo({
					top: 0,
					behavior: 'smooth',
				});
			});
		setResetSelections(false);
	}

	return (
		<>
			<ToastContainer
				id="warning-toast"
				position="top-right"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
			/>
			<div className={Styles.CardContainer}>
				<Typography
					variant="h6"
					sx={{
						display: 'flex',
						gap: '16px',
						padding: '16px',
						mb: '-15px',
						color: 'rgb(87, 79, 207)',
						justifyContent: 'space-between'
					}}
				>
					<BreadCrumbs
						onClickPaths={[
							'/quiz',
							''
						]}
						crumbs={
							props.t('CommonQuiz.QuizEnroll.breadCrumbs', { returnObjects: true })
						}
					/>
					<div id="enrollBtnContainer">
						<button
							className={Styles.enrollButton}
							onClick={() => {
								onEnroll();
							}}
						>
							<AddCircleOutlineTwoToneIcon />
							{props.t('CommonQuiz.QuizEnroll.button')}
								</button>
					</div>
				</Typography>
				{loading ? (
					<div>
						<LoadingBackdrop isOpen={true} />
					</div>
				) : quizList.length > 0 ? (
					quizList.map((quiz) => (
						<EnrollViewCard
							data={quiz}
							key={quiz.id}
							handleStreamSelection={handleLabSelection}
							resetSelections={resetSelections}
							maxSelected={false}
						/>
					))
				) : (
					<div style={{ paddingLeft: '22px' }}>
						{props.t('CommonQuiz.QuizEnroll.info')}	</div>
				)}
			</div>
		</>
	);
}
